import {GET_CITY_FAILED, GET_CITY_LOADING, GET_CITY_SUCCESS } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    Countries: null,
  };
  
  export const getAllCityReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_CITY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_CITY_SUCCESS:
        return {
          ...state,
          loading: false,
          Countries: action.payload,
          error: null,
        };
      case GET_CITY_FAILED:
        return {
          ...state,
          loading: false,
          Countries: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  